/* eslint-disable react-hooks/exhaustive-deps */

import { withStyles } from '@material-ui/core';

import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogTitle,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Tab,
  Tabs,
  TextField,
  Typography
} from '@mui/material';

import { LocalDate } from 'js-joda';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showToast } from 'modules/layout/layout.actions';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import {
  getHhgEstimates,
  getHhgItems,
  getHhgMovingDates,
  getHhgSegments,
  postHhgEstimate,
  postHhgSegment,
  updateHhgEstimate,
  updateHhgSegment
} from 'modules/authorizations/store/actions/houseHoldGoods.actions';

import PrimaryHhgInfo from './primaryHhgInfo.component';

import { DRAWER_WIDTH_CLOSED, DRAWER_WIDTH_CLOSED_XS, DRAWER_WIDTH_OPEN } from 'styles/theme';
import classNames from 'classnames';

import {
  POST_HHG_ESTIMATE_FAILURE,
  POST_HHG_SEGMENT_FAILURE,
  UPDATE_HHG_ESTIMATE_FAILURE,
  UPDATE_HHG_SEGMENT_FAILURE
} from 'modules/authorizations/store/types/houseHoldGoodsTypes';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import EstimatesActuals from './estimatesActuals.component';
import Spinner from 'modules/common/spinner.component';
import queryString from 'query-string';
import ServiceTriggeredComment from '../commentsAndNotes/serviceTriggeredComment.component';
import SlidingCommentsAndNotes from '../commentsAndNotes/commentsAndNotesSlidingPanel.component';
import { HHG_STATUS, ZERO_GUID } from 'modules/enumerations/enumerationIds';
import { isIdEqual } from 'modules/enumerations/enumerationHelpers';
import FullscreenSpinner from 'modules/common/fullscreenSpinner.component';
import { CreateVendorRelationshipList } from 'modules/authorizations/utils';
import AuthServiceCancellationToggleButton from 'modules/common/authServiceCancellationToggleButton.component';
import AuthServiceHoldToggleButton from 'modules/common/authServiceHoldToggleButton.component';
import StatusMenu from 'modules/common/statusMenu.component';
import { getServiceStatusDates } from 'modules/authorizations/store/actions/authorizations.actions';
import { formatMoney } from 'utilities/currencyFormatter';

const styles = theme => ({
  card: {
    width: '100%',
    maxWidth: 1500,
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  iconRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  dialogIconRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: '40px',
    paddingBottom: '20px'
  },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  },
  container: {
    height: 'auto',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    whiteSpace: 'nowrap',
    width: `calc(100% - ${DRAWER_WIDTH_CLOSED_XS}px)`,
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${DRAWER_WIDTH_CLOSED}px)`
    }
  },
  drawerOpen: {
    width: `calc(100% - ${DRAWER_WIDTH_OPEN})`
  },
  headerFixed: {
    zIndex: 4
  },
  tabFixed: {
    paddingTop: '100px',
    zIndex: 3
  },
  previewTabFixed: {
    paddingTop: '10px',
    zIndex: 3
  },
  estimateHeaderFixed: {
    paddingTop: '150px',
    zIndex: 2
  },
  previewEstimateHeaderFixed: {
    paddingTop: '15px',
    zIndex: 3
  }
});

export const HHG_STATUS_RANK = {
  [HHG_STATUS.initiated.toLowerCase()]: 2,
  [HHG_STATUS.ordered.toLowerCase()]: 3,
  [HHG_STATUS.survey.toLowerCase()]: 4,
  [HHG_STATUS.received.toLowerCase()]: 5,
  [HHG_STATUS.estimateAccepted.toLowerCase()]: 6,
  [HHG_STATUS.inTransit.toLowerCase()]: 7,
  [HHG_STATUS.delivered.toLowerCase()]: 8,
  [HHG_STATUS.completed.toLowerCase()]: 9,
  [HHG_STATUS.onHold.toLowerCase()]: 10,
  [HHG_STATUS.canceled.toLowerCase()]: 11,
  [HHG_STATUS.none.toLowerCase()]: 12
};

const getRank = statusId => {
  if (!statusId) return Number.MAX_SAFE_INTEGER;
  return HHG_STATUS_RANK[String(statusId).toLowerCase()] ?? Number.MAX_SAFE_INTEGER;
};

const HouseholdGoods = props => {
  const {
    details,
    location,
    vendors,
    shouldShowSideDrawer,
    hhgTypesEnum,
    moveTypesEnum,
    hHGServiceStatusTypesEnums,
    enumerations,
    emailTemplates,
    id,
    clientInfo
  } = props;

  const [statuses, setStatuses] = useState(
    details?.serviceStatusDates ? details.serviceStatusDates.filter(s => s.serviceType === 'HHGEstimates') : []
  );

  const getStatuses = async () => {
    if (details?.serviceStatusDates) {
      await props.getServiceStatusDates(id);
      setStatuses(details.serviceStatusDates.filter(s => s.serviceType === 'HHGEstimates'));
    }
  };

  useEffect(() => {
    //setCurrentStatus(props.enumerations.buyerStatuses.find(bs => bs.id === buyer.buyerStatusId)?.title ?? 'Initiated');
    getStatuses();
  }, []);

  const hhgMoveTypes =
    hhgTypesEnum && hhgTypesEnum.length > 0
      ? hhgTypesEnum.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const moveTypes =
    moveTypesEnum && moveTypesEnum.length > 0
      ? moveTypesEnum.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const hhgStatuses =
    hHGServiceStatusTypesEnums && hHGServiceStatusTypesEnums.length > 0
      ? hHGServiceStatusTypesEnums.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const authCommentServiceTypes =
    enumerations && enumerations.authCommentService && enumerations.authCommentService.length > 0
      ? enumerations.authCommentService.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const authCommentRegardingTypes =
    enumerations && enumerations.authCommentRegarding && enumerations.authCommentRegarding.length > 0
      ? enumerations.authCommentRegarding.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  let segments = details.hhgSegments || [];
  let selectedSegment = segments.length > 0 ? segments[segments.length - 1] : null;
  // Links to an estimate (such as from the HHG weights import results) open on its segment and estimate
  const linkParams = queryString.parse(location.search);
  const linkedSegment = segments.find(s => s?.segmentInfo?.hhgSegmentId === Number(linkParams.segmentId));
  const linkedEstimateId = linkedSegment?.estimates?.find(e => e?.estimateInfo?.hhgEstimateId === Number(linkParams.estimateId))?.estimateInfo.hhgEstimateId;
  const [segmentId, setSegmentId] = useState(linkedSegment?.segmentInfo.hhgSegmentId ?? selectedSegment?.segmentInfo.hhgSegmentId ?? null);

  const vendorsPreferredVendorSorted = CreateVendorRelationshipList(vendors, clientInfo?.clientDetails.clientVendorRelationships);

  const [currentTab, setCurrentTab] = useState(queryString.parse(location.search).tab ? queryString.parse(location.search).tab : 'PRIMARY');
  const [showAddSegment, setShowAddSegment] = useState(false);
  const [newDescription, setNewDescription] = useState('');
  const [newType, setNewType] = useState('00000000-0000-0000-0000-000000000000');
  const [isLoadingModal, setIsLoadingModal] = useState(false);

  const [estimateId, setEstimateId] = useState(
    linkedEstimateId ?? segments.find(s => s.segmentInfo.hhgSegmentId === segmentId)?.estimates?.[0]?.estimateInfo.hhgEstimateId ?? null
  );

  const [showAddEstimate, setShowAddEstimate] = useState(false);
  const [newEstimateDescription, setNewEstimateDescription] = useState('');
  const [isLoadingEstimates] = useState(false);

  const [showTriggeredComment, setShowTriggeredComment] = useState(false);
  const [showComment, setShowComment] = useState(false);
  const [estimateAccepted, setEstimateAccepted] = useState(
    details.hhgSegments &&
      details.hhgSegments.find(s => s.segmentInfo.hhgSegmentId === segmentId) &&
      details.hhgSegments
        .find(s => s.segmentInfo.hhgSegmentId === segmentId)
        .estimates.find(e => e.estimateInfo.hhgEstimateId === estimateId)
      ? details.hhgSegments
        .find(s => s.segmentInfo.hhgSegmentId === segmentId)
        .estimates.find(e => e.estimateInfo.hhgEstimateId === estimateId).estimateInfo.estimateAccepted
      : false
  );
  const setReadOnly = () => {
    if (!segmentId || !details || !details.hhgSegments) return false;

    // Canceling and holding apply to the whole service, so one canceled or on hold segment makes every segment read only.
    return details.hhgSegments.some(s => s?.segmentInfo?.canceledDate || s?.segmentInfo?.onHoldDate);
  };

  const isPreviewRoute = Boolean(location?.pathname?.includes('expenses')) || Boolean(location?.pathname?.includes('vouchers')) || Boolean(location?.pathname?.includes('recurringPayables'));
  const isViewOnly = Boolean(props.isReadOnly) || isPreviewRoute;
  const isReadOnly = isViewOnly || setReadOnly();
  const useFixedLayout = !isPreviewRoute;

  const calculateOverallCost = () => {
    if (!details || !details.hhgSegments) return 0;
    let totalCost = 0;
    details.hhgSegments.forEach(segment => {
      if (segment.estimates && segment.estimates.length > 0) {
        segment.estimates.forEach(estimate => {
          const estimateInfo = estimate.estimateInfo;
          if (estimateInfo) {
            const doorToDoor = parseFloat(estimateInfo.doorToDoorRate) || 0;
            const storage = parseFloat(estimateInfo.storageRate) || 0;
            const extraTransit = parseFloat(estimateInfo.extraTransitProtectionRate) || 0;
            const thirdParty = parseFloat(estimateInfo.thirdPartyEstimates) || 0;
            totalCost += doorToDoor + storage + extraTransit + thirdParty;
          }
        });
      }
    });
    return totalCost;
  };

  const createSegment = async () => {
    setIsLoadingModal(true);

    const resp = await props.postHhgSegment({
      authorizationId: props.id,
      hHGTypeId: newType,
      billToId: '00000000-0000-0000-0000-000000000000',
      hHGName: newDescription,
      // The segment is initiated on the day it is created, as the user sees that day in their own timezone.
      initiationDate: LocalDate.now().toString(),
      dateCreated: new Date().toISOString().split('T')[0]
    });

    if (resp.type === POST_HHG_SEGMENT_FAILURE) {
      props.showToast('Failed to update the hhg segment info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoadingModal(false);
    } else {
      const getSegmentsResp = await props.getHhgSegments(props.id);
      props.showToast('Segment created successfully.', { userMustDismiss: false, severity: 'success' });
      setSegmentId(getSegmentsResp.response[getSegmentsResp.response.length - 1].segmentInfo.hhgSegmentId);
      setShowAddSegment(false);
      setIsLoadingModal(false);
    }
  };

  const createEstimate = async () => {
    setIsLoadingModal(true);

    const resp = await props.postHhgEstimate(id, {
      hhgSegmentId: segmentId,
      estimateName: newEstimateDescription,
      estimateAccepted: false,
      estimateRequestSent: false,
      hasVendorAccepted: true,
      reasonNotAccepted: '',
      requestDetailsComment: '',
      landWeightTypeId: ZERO_GUID,
      airWeightTypeId: ZERO_GUID,
      seaWeightTypeId: ZERO_GUID,

      actualLandWeightTypeId: ZERO_GUID,
      actualAirWeightTypeId: ZERO_GUID,
      actualSeaWeightTypeId: ZERO_GUID,
      dateCreated: new Date().toISOString().split('T')[0]
    });

    if (resp.type === POST_HHG_ESTIMATE_FAILURE) {
      props.showToast('Failed to create the new hhg estimate, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoadingModal(false);
    } else {
      const getSegmentsResp = await props.getHhgSegments(props.id);
      props.showToast('Estimate created successfully.', { userMustDismiss: false, severity: 'success' });
      setEstimateId(
        getSegmentsResp.response.find(seg => seg.segmentInfo.hhgSegmentId === segmentId)
          ? getSegmentsResp.response.find(seg => seg.segmentInfo.hhgSegmentId === segmentId).estimates.slice(-1)[0].estimateInfo
            .hhgEstimateId
          : 0
      );
      setShowAddEstimate(false);
      setNewEstimateDescription('');
      setIsLoadingModal(false);
    }
  };

  const updateEstimateAccepted = async () => {
    setIsLoadingModal(true);

    const estimate =
      details.hhgSegments && details.hhgSegments.find(s => s.segmentInfo.hhgSegmentId === segmentId)
        ? details.hhgSegments
          .find(s => s.segmentInfo.hhgSegmentId === segmentId)
          .estimates.find(e => e.estimateInfo.hhgEstimateId === estimateId)
        : null;

    let newRequestBody = { ...estimate };
    newRequestBody.estimateInfo.estimateAccepted = !estimateAccepted;

    const resp = await props.updateHhgEstimate(id, newRequestBody);

    if (resp.type === UPDATE_HHG_ESTIMATE_FAILURE) {
      props.showToast('Failed to update the estimate accepted data, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoadingModal(false);
    } else {
      // Refresh segments data to get updated estimate info and recalculate status
      const getSegmentsResp = await props.getHhgSegments(id);

      // Update local state with the refreshed data
      const updatedSegment = getSegmentsResp.response.find(s => s.segmentInfo.hhgSegmentId === segmentId);
      const updatedEstimate = updatedSegment?.estimates.find(e => e.estimateInfo.hhgEstimateId === estimateId);

      if (updatedEstimate) {
        setEstimateAccepted(updatedEstimate.estimateInfo.estimateAccepted);
      }

      props.showToast('Estimate updated successfully.', { userMustDismiss: false, severity: 'success' });
      setIsLoadingModal(false);
    }
  };

  const changeTab = tab => {
    setCurrentTab(tab);
    const values = queryString.parse(location.search);
    values.tab = tab;
    props.history.replace(`${location.pathname}?${queryString.stringify(values)}`);
  };

  useEffect(() => {
    const estimates = details.hhgSegments?.find(s => s.segmentInfo.hhgSegmentId === segmentId)?.estimates ?? [];
    // Keep explicit selections, but never carry an estimate over from another segment.
    setEstimateId(currentEstimateId =>
      estimates.some(e => e.estimateInfo.hhgEstimateId === currentEstimateId)
        ? currentEstimateId
        : estimates[0]?.estimateInfo.hhgEstimateId ?? null
    );
  }, [segmentId, details.hhgSegments]);

  // Update estimateAccepted state when estimateId or segment changes
  useEffect(() => {
    const segment = details.hhgSegments?.find(s => s.segmentInfo.hhgSegmentId === segmentId);
    const estimate = segment?.estimates?.find(e => e.estimateInfo.hhgEstimateId === estimateId);
    setEstimateAccepted(estimate?.estimateInfo.estimateAccepted || false);
  }, [estimateId, segmentId, details.hhgSegments]);

  // The service is canceled or put on hold as a whole. Both dates are kept on the segments, and saving one segment
  // carries them to the rest.
  const isOnHold = () => Boolean(details?.hhgSegments?.some(s => s?.segmentInfo?.onHoldDate));

  const isCanceled = () => Boolean(details?.hhgSegments?.some(s => s?.segmentInfo?.canceledDate));

  const calculateHHGStatus = () => {
    const segment = details?.hhgSegments?.find(s => s?.segmentInfo?.hhgSegmentId === segmentId);
    if (!segment || !segment.segmentInfo) return 'Initiated';

    if (isCanceled()) return 'Canceled';

    if (isOnHold()) return 'On Hold';

    const estimates = segment?.estimates ?? [];

    let selected = { id: HHG_STATUS.initiated, rank: getRank(HHG_STATUS.none) };

    for (const item of estimates) {
      const statusId = item?.estimateInfo?.statusId ?? HHG_STATUS.none;
      const rank = getRank(statusId);
      if (rank < selected.rank) {
        selected = { id: statusId, rank };
      }
    }

    return hhgStatuses.find(s => isIdEqual(s.id, selected.id));
  };

  const hhgStatus = calculateHHGStatus();

  const getSelectedEstimateStatus = () => {
    if (!segmentId || !estimateId) return '';
    let segment = details.hhgSegments.find(s => s.segmentInfo.hhgSegmentId === segmentId);
    if (!segment) return '';

    let estimate = segment.estimates.find(s => s.estimateInfo.hhgEstimateId === estimateId);
    if (!estimate || !estimate.estimateInfo) return '';
    return hhgStatuses.find(s => isIdEqual(s.id, estimate.estimateInfo.statusId))?.title;
  };

  const updateSegmentStatusDates = async statusDates => {
    const segment = details.hhgSegments ? details.hhgSegments.find(s => s.segmentInfo.hhgSegmentId === segmentId) : null;
    if (!segment) return false;

    setIsLoadingModal(true);
    const request = {
      segmentInfo: { ...segment.segmentInfo, ...statusDates },
      storageAddress: { ...segment.storageAddress }
    };

    var response = await props.updateHhgSegment(request);
    if (response.type === UPDATE_HHG_SEGMENT_FAILURE) {
      props.showToast('Failed to update segment info, please try again later', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    } else {
      await props.getHhgSegments(id);
    }
    setIsLoadingModal(false);
  };

  // The service's own date, taken from whichever segment has it, since the selected segment is what gets saved and
  // carried to the rest.
  const getServiceStatusDate = dateName => details?.hhgSegments?.find(s => s?.segmentInfo?.[dateName])?.segmentInfo?.[dateName] ?? null;

  // Canceling and reactivating leave the hold alone, so a service that was on hold when it was canceled comes back on hold.
  const onHandleCancelService = () =>
    updateSegmentStatusDates({ canceledDate: new Date().toISOString(), onHoldDate: getServiceStatusDate('onHoldDate') });

  const onHandleReactivateService = () => updateSegmentStatusDates({ canceledDate: null, onHoldDate: getServiceStatusDate('onHoldDate') });

  const onHandleSetOnHold = () =>
    updateSegmentStatusDates({ onHoldDate: new Date().toISOString(), canceledDate: getServiceStatusDate('canceledDate') });

  const onHandleTakeOffHold = () => updateSegmentStatusDates({ onHoldDate: null, canceledDate: getServiceStatusDate('canceledDate') });

  const [openStatusMenu, setOpenStatusMenu] = useState(false);
  
  const hhgStatusOrder = [
    {
      title: 'Initiated',
      id:
        enumerations && enumerations.hHGServiceStatusTypes && enumerations.hHGServiceStatusTypes.length > 0
          ? enumerations.hHGServiceStatusTypes.find(s => s.title === 'Initiated')?.id
          : '',
      isActive: true,
      date: details?.services?.find(s => s.authorizationFileServiceTypeId === 'cce24947-254f-431a-97a9-2a1469161b8a')?.addedOn ?? null
    },
    {
      title: 'Ordered Estimates',
      id:
        enumerations && enumerations.hHGServiceStatusTypes && enumerations.hHGServiceStatusTypes.length > 0
          ? enumerations.hHGServiceStatusTypes.find(s => s.title === 'Ordered Estimates')?.id
          : '',
      isActive: true,
      date: selectedSegment?.estimates?.[0]?.estimateInfo?.orderedDate ?? null
    },
    {
      title: 'Survey Pending',
      id:
        enumerations && enumerations.hHGServiceStatusTypes && enumerations.hHGServiceStatusTypes.length > 0
          ? enumerations.hHGServiceStatusTypes.find(s => s.title === 'Survey Pending')?.id
          : '',
      isActive: true,
      date: selectedSegment?.estimates?.[0]?.estimateInfo?.appointmentDate ?? null
    },
    {
      title: 'Received Estimates',
      id:
        enumerations && enumerations.hHGServiceStatusTypes && enumerations.hHGServiceStatusTypes.length > 0
          ? enumerations.hHGServiceStatusTypes.find(s => s.title === 'Received Estimates')?.id
          : '',
      isActive: true,
      date: selectedSegment?.estimates?.[0]?.estimateInfo?.receivedDate ?? null
    },
    {
      title: 'Estimate Accepted',
      id:
        enumerations && enumerations.hHGServiceStatusTypes && enumerations.hHGServiceStatusTypes.length > 0
          ? enumerations.hHGServiceStatusTypes.find(s => s.title === 'Estimate Accepted')?.id
          : '',
      isActive: true,
      date: selectedSegment?.estimates?.[0]?.estimateInfo?.estimateAcceptedDate ?? null
    },
    {
      title: 'In Transit',
      id:
        enumerations && enumerations.hHGServiceStatusTypes && enumerations.hHGServiceStatusTypes.length > 0
          ? enumerations.hHGServiceStatusTypes.find(s => s.title === 'In Transit')?.id
          : '',
      isActive: true,
      date: selectedSegment?.estimates?.[0]?.movingDates?.filter(s => s.info?.isCallComplete)?.[0]?.info?.callCompleteDate ?? null
    },
    {
      title: 'Delivered',
      id:
        enumerations && enumerations.hHGServiceStatusTypes && enumerations.hHGServiceStatusTypes.length > 0
          ? enumerations.hHGServiceStatusTypes.find(s => s.title === 'Delivered')?.id
          : '',
      isActive: true,
      date: selectedSegment?.estimates?.[0]?.movingDates?.filter(s => s.info?.isDeliveryCallComplete)?.[0]?.info?.deliveryCallCompleteDate ?? null
    },
    {
      title: 'Canceled',
      id:
        enumerations && enumerations.globalServiceStatusTypes && enumerations.globalServiceStatusTypes.length > 0
          ? enumerations.globalServiceStatusTypes.find(s => s.title === 'Canceled')?.id
          : '',
      isActive: hhgStatus === 'Canceled' ? true : false,
      date: selectedSegment?.segmentInfo?.canceledDate ?? null
    },
    {
      title: 'On Hold',
      id:
        enumerations && enumerations.globalServiceStatusTypes && enumerations.globalServiceStatusTypes.length > 0
          ? enumerations.globalServiceStatusTypes.find(s => s.title === 'On Hold')?.id
          : '',
      isActive: hhgStatus === 'On Hold' ? true : false,
      date: selectedSegment?.segmentInfo?.onHoldDate ?? null
    },
    {
      title: 'Completed',
      id:
        enumerations && enumerations.globalServiceStatusTypes && enumerations.globalServiceStatusTypes.length > 0
          ? enumerations.globalServiceStatusTypes.find(s => s.title === 'Completed')?.id
          : '',
      isActive: hhgStatus === 'Completed' ? true : false,
      date: selectedSegment?.segmentInfo?.completedDate ?? null
    }
  ];

  return (
    <>
      <Box>
        {showComment && (
          <Box
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 1200,
              pointerEvents: 'none'
            }}
          />
        )}
        {true && (
          <>
            <Paper
              square
              className={classNames({
                'position-fixed': useFixedLayout,
                [props.classes.headerFixed]: useFixedLayout,
                [props.classes.container]: useFixedLayout,
                [props.classes.drawerOpen]: useFixedLayout && shouldShowSideDrawer
              })}
              sx={isPreviewRoute ? { position: 'relative', zIndex: 4, width: '100%' } : {}}
            >
              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>
                <Box sx={{ flex: '1 1 0' }}>
                  <div className={props.classes.mb2}>
                    <Typography variant="subtitle2">Segment</Typography>
                  </div>
                  <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                    <Select
                      labelId={'segmentSelect'}
                      key={'segmentSelect'}
                      label={''}
                      name={'segmentSelect'}
                      value={segmentId}
                      sx={{ maxWidth: '360px', minWidth: '180px' }}
                      onChange={e => setSegmentId(e.target.value)}
                    >
                      {segments &&
                        segments.map(opt => (
                          <MenuItem key={opt.segmentInfo.hhgSegmentId} value={opt.segmentInfo.hhgSegmentId} sx={{ margin: 'dense' }}>
                            {opt.segmentInfo.hhgName} (
                            {hhgMoveTypes && hhgMoveTypes.find(mt => mt.id === opt.segmentInfo.hhgTypeId) ? (
                              hhgMoveTypes.find(mt => mt.id === opt.segmentInfo.hhgTypeId).title
                            ) : (
                              <div>&mdash;</div>
                            )}
                            )
                          </MenuItem>
                        ))}
                    </Select>
                    {!isViewOnly && (
                      <Button
                        color="secondary"
                        type="submit"
                        variant="contained"
                        sx={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px' }}
                        disabled={isCanceled() || isOnHold()}
                        onClick={() => {
                          setShowAddSegment(true);
                          setNewDescription('');
                          setNewType('00000000-0000-0000-0000-000000000000');
                        }}
                      >
                        New Segment
                      </Button>
                    )}
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', paddingTop: '20px' }}>
                  <StatusMenu
                    anchorEl={openStatusMenu}
                    onClose={() => setOpenStatusMenu(false)}
                    currentStatus={hhgStatus}
                    statusHeader="HHG Status"
                    statusList={hhgStatusOrder}
                    statusDates={statuses}
                    classes={props.classes}
                    serviceInitiatedDate={segments.find(s => s.segmentInfo.hhgSegmentId === segmentId)?.segmentInfo?.initiationDate}
                  />
                  <Box>
                    <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                      <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                        Move Type
                      </Typography>
                    </Box>
                    <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                      <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                        {moveTypes && moveTypes.find(mt => mt.id === details.authorizationDetails.moveTypeId) ? (
                          moveTypes.find(mt => mt.id === details.authorizationDetails.moveTypeId).title
                        ) : (
                          <div>&mdash;</div>
                        )}
                      </Typography>
                    </Box>
                  </Box>
                  <Box>
                    <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                      <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                        Policy
                      </Typography>
                    </Box>
                    <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                      <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                        {props.clientInfo && props.clientInfo.clientDetails && props.clientInfo.clientDetails.clientRelocationPolicies ? (
                          details.authorizationDetails.relocationPolicyId ? (
                            props.clientInfo.clientDetails.clientRelocationPolicies.find(
                              crp => crp.policy.relocationPolicyId === details.authorizationDetails.relocationPolicyId
                            )?.policy?.policyDescription
                          ) : (
                            <div>&mdash;</div>
                          )
                        ) : (
                          <div>&mdash;</div>
                        )}
                      </Typography>
                    </Box>
                  </Box>
                  <Box>
                    <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                      <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                        Overall Cost
                      </Typography>
                    </Box>
                    <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                      <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                        {formatMoney(calculateOverallCost())}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <Box sx={{ flex: '1 1 0', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', paddingTop: '20px' }}>
                  {!isViewOnly && (
                    <>
                      <AuthServiceCancellationToggleButton
                        isCancelled={isCanceled()}
                        serviceName="Household Goods"
                        disabled={!segmentId || isLoadingModal}
                        sx={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px' }}
                        onServiceCancelled={onHandleCancelService}
                        onServiceReactivated={onHandleReactivateService}
                      />
                      {!isCanceled() && (
                        <AuthServiceHoldToggleButton
                          isOnHold={isOnHold()}
                          disabled={!segmentId || isLoadingModal}
                          sx={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px' }}
                          onSetOnHold={onHandleSetOnHold}
                          onTakeOffHold={onHandleTakeOffHold}
                        />
                      )}
                      <Button
                        onClick={() => setShowComment(true)}
                        variant="contained"
                        sx={{
                          maxHeight: '40px',
                          marginLeft: '12px',
                          marginTop: '8px',
                          backgroundColor: '#41B7C0',
                          color: 'white',
                          '&:hover': { backgroundColor: '#3d959c' }
                        }}
                      >
                        Comments
                      </Button>
                    </>
                  )}
                </Box>
              </Box>
            </Paper>
            <Paper
              square
              className={classNames({
                'position-fixed': useFixedLayout,
                [props.classes.tabFixed]: useFixedLayout,
                [props.classes.previewTabFixed]: isPreviewRoute,
                [props.classes.container]: useFixedLayout,
                [props.classes.drawerOpen]: useFixedLayout && shouldShowSideDrawer
              })}
              sx={isPreviewRoute ? { position: 'relative', zIndex: 3, width: '100%' } : {}}
            >
              <Tabs variant="fullWidth" value={currentTab} onChange={(event, tab) => changeTab(tab)} sx={{}}>
                <Tab value={'PRIMARY'} label="Segment Information" />
                <Tab value={'ESTIMATE'} label="Estimates" disabled={!segmentId} />
              </Tabs>
            </Paper>
            {isLoadingModal && (
              <Box
                square
                className={classNames({
                  'position-fixed': useFixedLayout,
                  [props.classes.estimateHeaderFixed]: useFixedLayout,
                  [props.classes.container]: useFixedLayout,
                  [props.classes.drawerOpen]: useFixedLayout && shouldShowSideDrawer
                })}
                sx={isPreviewRoute ? { position: 'relative', zIndex: 2, width: '100%' } : {}}
              >
                <FullscreenSpinner />{' '}
              </Box>
            )}
            {!isLoadingModal && currentTab === 'ESTIMATE' && segmentId != null && (
              <Paper
                square
                className={classNames({
                  'position-fixed': useFixedLayout,
                  [props.classes.estimateHeaderFixed]: useFixedLayout,
                  [props.classes.previewEstimateHeaderFixed]: isPreviewRoute,
                  [props.classes.container]: useFixedLayout,
                  [props.classes.drawerOpen]: useFixedLayout && shouldShowSideDrawer
                })}
                sx={isPreviewRoute ? { position: 'relative', zIndex: 2, width: '100%' } : {}}
              >
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>
                  <Box sx={{ display: 'flex', flexDirection: 'row', paddingLeft: '20px' }}>
                    <Select
                      labelId={'estimateId'}
                      key={'estimateId'}
                      label={''}
                      name={'estimateId'}
                      value={estimateId ?? ''}
                      sx={{ maxWidth: '360px', minWidth: '180px', maxHeight: '65px' }}
                      onChange={e => setEstimateId(e.target.value)}
                    >
                      {details.hhgSegments &&
                        details.hhgSegments.find(s => s.segmentInfo.hhgSegmentId === segmentId) &&
                        details.hhgSegments
                          .find(s => s.segmentInfo.hhgSegmentId === segmentId)
                          .estimates.map(opt => (
                            <MenuItem key={opt.estimateInfo.hhgEstimateId} value={opt.estimateInfo.hhgEstimateId} sx={{ margin: 'dense' }}>
                              {opt.estimateInfo.estimateName}
                            </MenuItem>
                          ))}
                    </Select>
                    <Button
                      color="secondary"
                      type="submit"
                      variant="contained"
                      sx={{ maxHeight: '40px', marginLeft: '12px', marginTop: '10px' }}
                      onClick={() => setShowAddEstimate(true)}
                      disabled={isReadOnly}
                    >
                      New Estimate{' '}
                    </Button>
                  </Box>
                  {estimateId && (
                    <>
                      <Box>
                        <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                          <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                            Estimate Status
                          </Typography>
                        </Box>
                        <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                          <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                            {getSelectedEstimateStatus()}
                          </Typography>
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', flexDirection: 'row', paddingLeft: '20px' }}>
                        <div>
                          <FormControl sx={{ marginTop: '20px', marginBottom: '1px' }}>
                            <FormControlLabel
                              key={'estimateAccepted'}
                              name={'estimateAccepted'}
                              label={'Estimate Accepted'}
                              labelPlacement="start"
                              control={<Checkbox />}
                              required={false}
                              disabled={isReadOnly}
                              checked={estimateAccepted}
                              variant="standard"
                              margin="dense"
                              sx={{ minWidth: '20px', maxWidth: '60px', maxHeight: '20px', marginRight: '10px' }}
                              onClick={e => {
                                setEstimateAccepted(e.target.checked ? true : false);
                                updateEstimateAccepted();
                              }}
                            />
                          </FormControl>
                        </div>
                        {estimateAccepted && (
                          <>
                            <Box>
                              <TextField
                                key={'estimateAcceptedDate'}
                                label={'Estimate Accepted Date'}
                                name={'estimateAcceptedDate'}
                                disabled={true}
                                value={new Date().toLocaleDateString()}
                                sx={{ maxWidth: '360px' }}
                                margin="dense"
                                variant="standard"
                                InputLabelProps={{ shrink: true }}
                                onChange={e => setNewDescription(e.target.value)}
                              />
                            </Box>
                          </>
                        )}
                      </Box>
                    </>
                  )}
                </Box>
              </Paper>
            )}

            {!isLoadingModal && segmentId == null && (
              <Box sx={{ padding: '20px', paddingTop: '165px', fontSize: '20px' }}>
                <b>No segment selected. Create a new segment above to get started.</b>
              </Box>
            )}
            {!isLoadingModal && segmentId != null && (
              <Box
                sx={{
                  padding: '20px',
                  paddingTop: currentTab === 'ESTIMATE' ? isPreviewRoute ? '25px' : '245px' : isPreviewRoute ? '25px' : '165px'
                }}
              >
                {currentTab === 'PRIMARY' && (
                  <PrimaryHhgInfo
                    details={details}
                    vendors={vendorsPreferredVendorSorted}
                    segmentId={segmentId}
                    location={location}
                    hHGServiceStatusTypes={hhgStatuses}
                    id={props.id}
                    isReadOnly={isReadOnly}
                    emailTemplates={emailTemplates}
                    history={props.history}
                    authCommentRegardingTypes={authCommentRegardingTypes}
                    authCommentServiceTypes={authCommentServiceTypes}
                    enumerations={enumerations}
                  />
                )}
                {currentTab === 'ESTIMATE' && (
                  <EstimatesActuals
                    estimateId={estimateId}
                    currentTab={currentTab}
                    details={details}
                    location={location}
                    segmentId={segmentId}
                    isLoadingEstimates={isLoadingEstimates}
                    id={props.id}
                    isReadOnly={isReadOnly}
                    vendors={vendorsPreferredVendorSorted}
                    selectedAuthServiceId={segmentId}
                    history={props.history}
                    authCommentRegardingTypes={authCommentRegardingTypes}
                    authCommentServiceTypes={authCommentServiceTypes}
                    emailTemplates={emailTemplates}
                    sentEmailTemplates={details.sentEmailTemplates}
                  />
                )}{' '}
              </Box>
            )}
          </>
        )}
        <Dialog open={showAddSegment} fullWidth={false} maxWidth={'lg'}>
          <Box sx={{ display: 'flex', flexDirection: 'row', padding: '20px' }}>
            <Box sx={{ marginRight: '20px' }}>
              <TextField
                key={'newDescription'}
                label={'Name'}
                name={'newDescription'}
                required={true}
                disabled={false}
                value={newDescription} // formatDateForInput(values[summary.accessorKey])
                sx={{ maxWidth: '360px' }}
                margin="dense"
                variant="standard"
                InputLabelProps={{ shrink: true }}
                onChange={e => setNewDescription(e.target.value)}
              />
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </Box>
            <Box>
              <FormControl sx={{ marginTop: '6px' }}>
                <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'hhgType'}>
                  HHG Type
                </InputLabel>
                <Select
                  labelId={'hhgType'}
                  key={'hhgType'}
                  label={'hhgType'}
                  name={'hhgType'}
                  required={true}
                  disabled={false}
                  value={newType}
                  margin="dense"
                  variant="standard"
                  sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                  onChange={e => setNewType(e.target.value)}
                >
                  {hhgMoveTypes.map(opt => (
                    <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }}>
                      {opt.title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </Box>
          </Box>
          <DialogActions sx={{ p: '1.25rem' }}>
            {isLoadingModal && <Spinner />}
            {!isLoadingModal && (
              <>
                <Button onClick={() => setShowAddSegment(false)}>Cancel</Button>
                <Button
                  onClick={createSegment}
                  color="primary"
                  type="submit"
                  variant="contained"
                  disabled={!(newDescription && newDescription.length > 0)}
                >
                  Create Segment
                </Button>
              </>
            )}
          </DialogActions>
        </Dialog>
        <Dialog open={showAddEstimate} fullWidth={false} maxWidth={'lg'}>
          <DialogTitle>Create New Estimate</DialogTitle>
          <Box sx={{ display: 'flex', flexDirection: 'row', padding: '20px' }}>
            <Box>
              <TextField
                key={'newEstimateDescription'}
                label={'Name of Estimate'}
                name={'newEstimateDescription'}
                required={true}
                disabled={isReadOnly}
                value={newEstimateDescription} // formatDateForInput(values[summary.accessorKey])
                sx={{ maxWidth: '360px', minWidth: '275px', marginRight: '10px' }}
                margin="dense"
                variant="standard"
                InputLabelProps={{ shrink: true }}
                onChange={e => setNewEstimateDescription(e.target.value)}
              />
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </Box>
          </Box>
          {/* <Box sx={{ display: 'flex', flexDirection: 'row', padding: '20px' }}>
            <Box>
              <TextField
                key={'startLocation'}
                label={'Start Location'}
                name={'startLocation'}
                required={false}
                disabled={true}
                sx={{ maxWidth: '360px', minWidth: '275px', marginRight: '10px' }}
                margin="dense"
                variant="standard"
                InputLabelProps={{ shrink: true }}
              />
            </Box>
            <Box>
              <TextField
                key={'endLocation'}
                label={'End Location'}
                name={'endLocation'}
                required={false}
                disabled={true}
                sx={{ maxWidth: '360px', minWidth: '275px', marginRight: '10px' }}
                margin="dense"
                variant="standard"
                InputLabelProps={{ shrink: true }}
              />
            </Box>
            <Box>
              <TextField
                key={'vendor'}
                label={'Vendor'}
                name={'vendor'}
                required={false}
                disabled={true}
                value={newEstimateSegment && newEstimateSegment.storageVendorCompanyName ? newEstimateSegment.storageVendorCompanyName : ''}
                sx={{ maxWidth: '360px', minWidth: '275px', marginRight: '10px' }}
                margin="dense"
                variant="standard"
                InputLabelProps={{ shrink: true }}
              />
            </Box>
          </Box> */}
          <DialogActions sx={{ p: '1.25rem' }}>
            {isLoadingModal && <Spinner />}
            {!isLoadingModal && (
              <>
                <Button onClick={() => setShowAddEstimate(false)}>Cancel</Button>
                <Button
                  onClick={createEstimate}
                  color="primary"
                  type="submit"
                  variant="contained"
                  disabled={!(newEstimateDescription && newEstimateDescription.length > 0)}
                >
                  Create Estimate
                </Button>
              </>
            )}
          </DialogActions>
        </Dialog>
      </Box>
      {showTriggeredComment && (
        <ServiceTriggeredComment
          authorizationId={id}
          serviceOptionId={'e8d4399d-b059-4fcb-9959-fc64c4bb25f3'}
          displayText={'Household Goods - Service Completed Comment'}
          setShowTriggeredComment={setShowTriggeredComment}
        />
      )}
      {showComment && (
        <SlidingCommentsAndNotes
          authorizationId={id}
          serviceOptionId={'e8d4399d-b059-4fcb-9959-fc64c4bb25f3'}
          setShowComment={setShowComment}
          isOpen={true}
        />
      )}
    </>
  );
};

HouseholdGoods.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  const { hHGTypes, moveTypes, hHGServiceStatusTypes } = state.enumerations.allEnums;
  return {
    shouldShowSideDrawer: state.layout.shouldShowSideDrawer,
    hhgTypesEnum: hHGTypes,
    moveTypesEnum: moveTypes,
    hHGServiceStatusTypesEnums: hHGServiceStatusTypes
  };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    getHhgSegments,
    postHhgSegment,
    showToast,
    getHhgMovingDates,
    getHhgItems,
    getHhgEstimates,
    postHhgEstimate,
    updateHhgEstimate,
    updateHhgSegment,
    getServiceStatusDates
  })
)(HouseholdGoods);
